//PanelContentTabService
(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-refresh-tab-visibility', actionFunc);

    function actionFunc($q, lodash, PanelContentTabService) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                console.log('action-refresh-tab-visibility');
                const identifier = lodash.get(options, 'identifier', null);

                PanelContentTabService.refreshTabVisibility(identifier);
            }
        };
    }
})();